<template>
  <div class="agree">
    <Header propsTitle="회원 가입 하기" @clickBack="clickBack" />
    <div class="container">
      <div class="page-inner">
        <!-- 단계 표시 UI -->
        <Stepper step="1" />
        <h1 class="step-title">이용 약관 동의</h1>

        <v-form ref="form">
          <div class="check-group">
            <h4>
              <v-checkbox v-model="userData.agreeAll" on-icon="mdi-check-circle" off-icon="mdi-check-circle-outline"
                label="전체 동의합니다." @click="clickAll(userData.agreeAll)" />
            </h4>
            <div class="checkbox-row">
              <v-checkbox required v-model="userData.agreeTerms" on-icon="mdi-check-circle"
                off-icon="mdi-check-circle-outline" label="이용약관 동의" :rules="[
                  () => !!userData.agreeTerms || '이용약관 동의는 필수 입니다.',
                ]">
                <template v-slot:label>
                  이용약관 동의 <span class="text-red">(필수)</span>
                </template>
              </v-checkbox>
              <v-btn icon x-small @click="clickAgreeDetail('term')">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
            <div class="checkbox-row">
              <v-checkbox required v-model="userData.agreePolicy" on-icon="mdi-check-circle"
                off-icon="mdi-check-circle-outline" label="개인정보 수집 이용 동의" :rules="[
                  () =>
                    !!userData.agreePolicy ||
                    '개인정보 수집 이용 동의는 필수 입니다.',
                ]">
                <template v-slot:label>
                  개인정보 수집 이용 동의 <span class="text-red">(필수)</span>
                </template>
              </v-checkbox>
              <v-btn icon x-small @click="clickAgreeDetail('policy')">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>

            <div class="checkbox-row">
              <v-checkbox required v-model="userData.checkAge" on-icon="mdi-check-circle"
                off-icon="mdi-check-circle-outline" label="본인은 만 14세 이상입니다" :rules="[
                  () => !!userData.checkAge || '14세 이상 확인은 필수 입니다.',
                ]">
                <template v-slot:label>
                  본인은 만 14세 이상입니다 <span class="text-red">(필수)</span>
                </template>
              </v-checkbox>
            </div>
            <div class="checkbox-row">
              <v-checkbox required v-model="userData.marketing" on-icon="mdi-check-circle"
                off-icon="mdi-check-circle-outline" label="마케팅 수집 이용 동의">
                <template v-slot:label>
                  마케팅 수집 이용 동의 <span>(선택)</span>
                </template>
              </v-checkbox>
              <v-btn icon x-small @click="clickAgreeDetail('marketing')">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
          <div class="bottom-btn">
            <v-btn color="primary" x-large outlined block rounded class="mb-3" @click="clickCancel">이전으로</v-btn>
            <v-btn color="primary" x-large depressed block rounded @click="clickNext">
              다음으로
            </v-btn>
            <!-- <v-btn color="" x-large depressed block rounded @click="clickCancel">
            취소
          </v-btn> -->
          </div>
        </v-form>
      </div>
    </div>


    <!-- 약관 상세보기 팝업 -->
    <SignUpAgreeDetailDialog ref="SignUpAgreeDetailDialog" />
  </div>
</template>

<script>
import Header from "./common/Header.vue";
import Stepper from "./agree/Stepper.vue";
import SignUpAgreeDetailDialog from "./agree/SignUpAgreeDetailDialog.vue";
export default {
  components: {
    Header,
    SignUpAgreeDetailDialog,
    Stepper,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    clickAll(e) {
      this.userData.agreeTerms = true;
      this.userData.agreePolicy = true;
      this.userData.checkAge = true;
      this.userData.marketing = true;
      if (!e) {
        this.userData.marketing = false;
        this.userData.agreeTerms = false;
        this.userData.checkAge = false;
        this.userData.agreePolicy = false;
      }
    },
    clickAgreeDetail(tab) {
      switch (tab) {
        case 'term':
        this.$refs.SignUpAgreeDetailDialog.open(tab);
          break;
        case 'policy': 
          window.open('https://www.bayer.com/ko/kr/korea-privacy-statement', '_blank');
          break;
        case 'marketing':
          this.$refs.SignUpAgreeDetailDialog.open(tab);
          break;
      }
    },
    clickNext() {
      if (!this.$refs.form.validate()) return;
      this.userData.checkSms = false;
      this.$emit("clickNext", "sms");
    },
    clickCancel() {
      this.$emit("clickCancel");
    },
    clickBack() {
      this.$emit("clickBack");
    }
  },
};
</script>

<style lang="scss">
.hGap {
  height: 10px;
}

.step-title {
  text-align: center;
  margin-bottom: 20px;
}

.agree {
  padding: 0;

  .section-inner {
    max-width: 800px;
  }

  .signup-header {
    padding: 1rem;
    text-align: center;
    //background: $mid-green;
    color: #ffffff;
  }

  .check-group {
    padding: 2rem 20px 1rem;

    h4 {
      border-bottom: 1px solid #ddd;
    }
  }

  .checkbox-row {
    position: relative;

    .v-input--checkbox {
      margin-top: 10px;

      &:not(.error--text) {
        .v-input__slot {
          margin-bottom: 0;
        }

        .v-messages {
          display: none;
        }
      }

      .v-label {
        font-size: 14px;

        span {
          display: inline-block;
          margin-left: 5px;

          &:not(.text-red) {
            color: #aaa;
          }
        }
      }
    }

    .v-btn {
      position: absolute;
      right: 0;
      top: 11px;
      background: #ffffff;

      .v-icon {
        color: $btn-primary-color;
      }
    }
  }
}

// @media (max-width: 768px) {
//   div.agree {
//     padding: 4rem 0 8rem;
//   }
// }
</style>